(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-menu-toggle]');
      const close = this.querySelector('[data-drawer-close]');
      if (toggle) toggle.addEventListener('click', () => this.open());
      if (close) close.addEventListener('click', () => this.closeDrawer());

      // Close on link click (so navigation feels snappy on mobile)
      this.querySelectorAll('.site-header__drawer-link, .site-header__drawer-phone')
        .forEach(el => el.addEventListener('click', () => this.closeDrawer()));

      // Close with Escape
      this.escapeHandler = (e) => { if (e.key === 'Escape') this.closeDrawer(); };
      document.addEventListener('keydown', this.escapeHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.escapeHandler);
    }

    open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    closeDrawer() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dotsHost = this.querySelector('[data-dots]');
      this.slides = Array.from(this.track.children);

      if (this.slides.length === 0) return;

      this.buildDots();
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });

      if (this.hasAttribute('autoplay')) {
        this.intervalMs = parseInt(this.getAttribute('interval') || '6000', 10);
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.go(1, true), this.intervalMs);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    buildDots() {
      this.dotsHost.innerHTML = '';
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'hero-slider__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Bild ${i + 1}`);
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => this.scrollTo(i));
        this.dotsHost.appendChild(dot);
      });
    }

    currentIndex() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    scrollTo(index) {
      const i = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }

    go(delta, fromTimer) {
      this.scrollTo(this.currentIndex() + delta);
    }

    syncDots() {
      const i = this.currentIndex();
      this.dotsHost.querySelectorAll('.hero-slider__dot').forEach((d, di) => {
        if (di === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent || '[]');
      this.priceMap = JSON.parse(this.querySelector('[data-variant-prices]').textContent || '{}');
      this.optionInputs = this.querySelectorAll('[data-option-input]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.addBtn = this.querySelector('.product__add-btn');
      this.addLabel = this.addBtn ? this.addBtn.querySelector('.btn__label') : null;
      const wrapper = this.querySelector('[data-add-wrapper]');
      this.labels = {
        add: wrapper ? wrapper.dataset.addLabel : 'In den Warenkorb',
        soldOut: wrapper ? wrapper.dataset.soldOutLabel : 'Ausverkauft',
        unavailable: wrapper ? wrapper.dataset.unavailableLabel : 'Nicht verfügbar'
      };

      this.optionInputs.forEach(input => {
        input.addEventListener('change', () => this.update());
      });

      // Quantity controls
      const qty = this.querySelector('[data-qty-input]');
      this.querySelector('[data-qty-decrement]').addEventListener('click', () => {
        qty.value = Math.max(1, parseInt(qty.value, 10) - 1);
      });
      this.querySelector('[data-qty-increment]').addEventListener('click', () => {
        qty.value = parseInt(qty.value, 10) + 1;
      });

      // Media thumbnails
      this.querySelectorAll('[data-media-target]').forEach(btn => {
        btn.addEventListener('click', () => this.showMedia(btn.dataset.mediaTarget));
      });
    }

    selectedOptions() {
      const opts = [];
      // Group inputs by option fieldset and find checked value
      this.querySelectorAll('.product__option').forEach(field => {
        const checked = field.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    update() {
      const selected = this.selectedOptions();
      // Mark selected labels
      this.querySelectorAll('.product__option-value').forEach(label => {
        const input = label.querySelector('input');
        label.classList.toggle('is-selected', input.checked);
      });

      // Find matching variant
      const variant = this.variants.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      );

      // No variant matches the selected options → "Nicht verfügbar"
      if (!variant) {
        if (this.addBtn) this.addBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = this.labels.unavailable;
        return;
      }

      this.variantInput.value = variant.id;
      const formatted = this.priceMap[variant.id] || '';
      if (this.priceEl) this.priceEl.textContent = formatted;

      // Sold-out variant → disable + "Ausverkauft", hide price from label
      if (!variant.available) {
        if (this.addBtn) this.addBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = this.labels.soldOut;
        return;
      }

      // Available variant → enable, show "Add to cart — €X.XX"
      if (this.addBtn) this.addBtn.disabled = false;
      if (this.addLabel) {
        this.addLabel.innerHTML = `${this.labels.add} — <span data-add-price>${formatted}</span>`;
      }
    }

    showMedia(index) {
      this.querySelectorAll('[data-media-image]').forEach(img => {
        const match = img.dataset.mediaImage === index;
        if (match) img.removeAttribute('hidden');
        else img.setAttribute('hidden', '');
      });
      this.querySelectorAll('[data-media-target]').forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.mediaTarget === index);
      });
    }
  }

  customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();
})();
